import { Component, OnInit, ViewChild, signal } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MasterService } from './../../home/services/master.service';
import { CommonAlertService } from './../../services/common-alert.service';
import { BASE_URL } from '../../config/config';
import { Router, ActivatedRoute } from '@angular/router';
import { StockService } from '../services/stocks.service';
import { MessagePopupComponent } from './modals/message-popup/message-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { PaginationComponent } from '../common/pagination/pagination.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { timestampFormat } from '../../../app/config/moment';
import { WarehouseService } from '../services/warehouse.service';

@Component({
  selector: 'app-bulk-upload',
  standalone: true,
  imports: [
    PaginationComponent,
    CommonModule,
    FormsModule
  ],
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss', '../../app.component.scss']
})


export class BulkUploadComponent implements OnInit {
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;

  public timestampFormat = timestampFormat;
  public activeTab: string = 'warehouse';
  public fileType = "";
  public fileName = "";
  public uploadedFile: any;
  public isFile = false;
  public statusType: string = "";
  public statusMessage: string = "";


  public uploadedSummary: any = [];
  public isUploadedSummary: boolean = false;

  public totalPages: number = 0;
  public currentPage: number = 1;

  public totalImplants: number = 0;

  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public isPrinterConnected = false;
  public isPrinterLoader = false;

  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;

  public selectedUploadedFor = [];

  public uploadedAtSortValue: string = "";
  public orderBy: string = "asc";

  public isDragOver = signal(false);

  public BASE = BASE_URL.URL;

  public cabinetProducts: any = [];
  public currentCabinetId: string = '';
  public selectedStatus = [];

  public expirySortValue: string = "";
  public lastUpdatedAtSortValue: string = "";
  product: any;


  public summaryDetails: any = [];
  public summaryProducts: any = [];
  public warehouseId: string = "4";
  public warehouses: any = [];
  public shipmentId: string = "";

  public isSummaryProducts: boolean = false;
  constructor(
    private spinnerService: NgxSpinnerService,
    public dialog: MatDialog,
    public stockService: StockService,
    private warehouseService: WarehouseService,
    public masterService: MasterService,
    public commonAlertService: CommonAlertService,
    public activatedRoute: ActivatedRoute,
    public router: Router) {

  }

  ngOnInit() {
    this.getBulkUploadSummary("", this.activeTab);
    this.connectToPrinter();
  }

  getWarehouses(){
    this.masterService.getIndexGet('/warehouses').subscribe((res) => {
      if (res.data && Array.isArray(res.data)) {
        this.warehouses = res.data;
        // Set default warehouse to first one if available
        if (this.warehouses.length > 0) {
          this.warehouseId = this.warehouses[0].id.toString();
        }
      }
    });
  }

  getBulkUploadSummary(page: string = "", uploadedFor: string = "", uploadedAt: string = "") {
    this.stockService.getBulkUploadSummary(page, uploadedFor, uploadedAt).subscribe({
      next: (res) => {
        if (res.data) {
          if (res.data.data.length !== 0) {
            this.totalPages = res.data.last_page;
            this.uploadedSummary = res.data.data;

            if (this.isSearch || this.isFilter) {
              this.isFilterResult = true;
            } else {
              this.isUploadedSummary = true;
            }
          } else {
            this.totalPages = 0;
            if (this.isSearch || this.isFilter) {
              this.isFilterResult = false;
            } else {
              this.isUploadedSummary = false;
            }
          }
        }
      },
      error: (err) => {
        console.error('Failed to fetch bulk upload summary:', err);
        this.statusType = 'error';
        this.statusMessage = 'Failed to load upload summary. Please try again.';
        this.showWarningToast();
        this.isUploadedSummary = false;
        this.totalPages = 0;
      }
    });
  }

  getBulkUploadSummaryDetails(event: any, summaryId: string, callback: any = null, callback_data: any = null) {
    this.stockService.getBulkUploadSummaryDetails(summaryId).subscribe({
      next: (res) => {
        if (res.data) {
          if (res.data.length !== 0) {
            if (!callback) {
              let currentSummary = this.uploadedSummary.find((el) => el.id == summaryId);
              if (currentSummary) {
                currentSummary.implants = res.data;
                // Don't call onAccordionChange here as it's already handled in the click event
              }
            }
          }
          if (callback) callback(res?.data, callback_data);
        }
      },
      error: (err) => {
        console.error('Failed to fetch summary details:', err);
        this.statusType = 'error';
        this.statusMessage = 'Failed to load summary details. Please try again.';
        this.showWarningToast();
      }
    });
  }

  uploadedAtSort() {
    this.isFilter = true;

    if (this.uploadedAtSortValue === "asc") {
      this.uploadedAtSortValue = "desc";
    } else {
      this.uploadedAtSortValue = this.orderBy;
    }

    this.onFilterChange();
  }

  onFilterChange() {
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }

    this.getBulkUploadSummary("", this.activeTab, this.uploadedAtSortValue);
  }

  getQueryPage($event: number) {
    this.currentPage = $event;
    this.getBulkUploadSummary(`${this.currentPage}`, this.activeTab, this.uploadedAtSortValue);
  }

  onSubmit() {
    this.spinnerService.show();
    let formData = new FormData();

    formData.append('file', this.uploadedFile);

    let loggedUser = JSON.parse(localStorage.getItem('role'));

    formData.append('warehouse_id', loggedUser.resource_id);

    let token = localStorage.getItem('token');

    fetch(`${this.BASE}/bulk-stocks/upload/${this.fileType}`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then((response) => {
      if (response.status === 200) {
        if (response.headers.get('Content-Type') === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          const uploadeEntries = response.headers.get('Uploaded-Entries');
          const invalidEntries = response.headers.get('Invalid-Entries');
          let fileName = `${this.fileType}-error`;
          return response.blob().then((blobContent) => {
            this.getBulkUploadSummary("", this.activeTab);

            this.openDialog(blobContent, uploadeEntries, invalidEntries, fileName);
          })
        } else if (response.headers.get('Content-Type') === "application/json") {
          this.statusType = 'success';
          this.statusMessage = `The ${this.uploadedFile.name} data has been uploaded successfully!`;
          this.showWarningToast();
          this.getBulkUploadSummary("", this.activeTab);
        }
      }

      if (response.status === 204) {
        this.statusType = 'success';
        this.statusMessage = 'Nothing to update';
        this.showWarningToast();
      }

      if (response.status === 422) {
        this.statusType = 'error';
        this.statusMessage = 'Unprocessable Content';
        this.showWarningToast();

        response.json().then((jsonData) => {
          if (!jsonData.data.excluded) {
            this.statusType = 'error';
            this.statusMessage = 'Error: The uploaded file and uploaded for doesn’t match';
            this.showWarningToast();
          }
        })
      }

      if (response.status === 401) {
        localStorage.clear();
        this.router.navigateByUrl('/login');
        this.spinnerService.hide();
        return;
      }

      if (response.status === 500) {
        this.statusType = 'error';
        this.statusMessage = `Oops, Something went wrong!`;
        this.showWarningToast();
      }
    })
      .catch((err) => {
        this.spinnerService.hide();
        console.log('err', err);
      }).finally(() => {
        this.spinnerService.hide();
      })
  }

  openUploadedForPopup(event) {
    document.getElementById("uploaded_for-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("uploaded_for-popup");
  }

  onUploadedForFilterChange(event) {
    if (event.target.checked) {
      this.selectedUploadedFor.push(event.target.value);
    } else {
      this.selectedUploadedFor = this.selectedUploadedFor.filter((element) => {
        return element !== event.target.value;
      });
    }

    this.isFilter = true;

    this.onFilterChange();
  }

  downloadTemplateFile($event: Event, type: string) {
    if ($event) $event.stopPropagation();
    this.stockService.downloadBulkUploadTemplate(type);
  }

  downloadUploadedRecords(id: string, type: string) {
    this.spinnerService.show();
    this.stockService.downloadUploadedRecords(id).subscribe({
      next: (res) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(res);
        // Generate a proper filename with timestamp and extension
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const filename = `${type}_summary_${timestamp}.xlsx`;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(link.href);
        this.spinnerService.hide();
      },
      error: (err) => {
        console.error('Download failed:', err);
        this.statusType = 'error';
        this.statusMessage = 'Failed to download the file. Please try again.';
        this.showWarningToast();
        this.spinnerService.hide();
      }
    });
  }

  openFileTypeDropdown(event) {
    let popupDiv = document.getElementById("file-type-dropdown");

    if (!popupDiv.className.includes("active")) {
      popupDiv.classList.add("active");
      event.stopPropagation()
      this.closePopupOutside("file-type-dropdown");
    }
  }

  //drag and drop
  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file)
    }

    this.isDragOver.set(false);
  }
  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);
  }
  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }
  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  browseFile(e) {
    e.preventDefault();
    let fileInput = document.getElementById("file-input");
    fileInput.click();
  }

  onFileChange(event) {
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  onFileTypeChange(type: string) {
    this.fileType = type;
  }
  //drag and drop

  fileValidation(file) {
    const validFileTypes = ['csv', 'xlsx', 'xls'];
    let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (validFileTypes.includes(ext)) {
      this.isFile = true;
      this.uploadedFile = file;
    } else {
      this.statusType = 'error';
      this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
      this.showWarningToast();
    }
  }

  resetFile() {
    this.isFile = false;
  }

  showWarningToast() {
    const toastContainer = document.getElementById('warning-toast');

    setTimeout(function () {
      toastContainer.classList.add('show');
    }, 100);

    setTimeout(function () {
      toastContainer.classList.remove('show');
    }, 5000);
  }

  openDialog(blob, uploadeEntries: string, invalidEntries: string, fileName: string): void {
    const dialogRef = this.dialog.open(MessagePopupComponent, {
      data: {
        blob,
        uploadeEntries,
        invalidEntries,
        fileName
      }
    });

    dialogRef.afterClosed().subscribe(result => { });
  }

  closePopupOutside(popupId: string) {
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function (event: any) {
      if (
        popupDiv.className.includes("active")
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }

  toggleAccordion(event: any, level: string, itemId: string) {
    event.stopPropagation();
    
    if (level === 'level1') {
      // Level 1 accordion (Upload Summary)
      const accordionItem = event.target.closest('.accordion-item');
      const accordionBody = accordionItem.querySelector('.accordion-body');
      const accordionArrow = accordionItem.querySelector('.accordion-arrow');
      
      if (accordionBody && accordionArrow) {
        // Toggle the expanded class
        accordionItem.classList.toggle('expanded');
        
        // Toggle the show class for the body
        accordionBody.classList.toggle('show');
        
        // Rotate the arrow
        accordionArrow.classList.toggle('rotated');
        
        // If expanding and no implants data, fetch it
        if (accordionItem.classList.contains('expanded') && itemId) {
          const currentSummary = this.uploadedSummary.find((el) => el.id == itemId);
          if (currentSummary && !currentSummary.implants) {
            this.getBulkUploadSummaryDetails(event, itemId);
          }
        }
      }
    } else if (level === 'level2') {
      // Level 2 accordion (Implant Details)
      const implantItem = event.target.closest('.implant-item');
      const stocksContainer = implantItem.querySelector('.stocks-container');
      const implantArrow = implantItem.querySelector('.implant-arrow');
      
      if (stocksContainer && implantArrow) {
        // Toggle the expanded class
        implantItem.classList.toggle('expanded');
        
        // Toggle the show class for the stocks container
        stocksContainer.classList.toggle('show');
        
        // Rotate the arrow
        implantArrow.classList.toggle('rotated');
      }
    }
  }

  openNextLevel(event: any, level: string, itemId: string) {
    event.stopPropagation();
    
    if (level === 'level1') {
      // Open Level 2 (Implants) - first ensure Level 1 is expanded
      const accordionItem = event.target.closest('.accordion-item');
      const accordionBody = accordionItem.querySelector('.accordion-body');
      const accordionArrow = accordionItem.querySelector('.accordion-arrow');
      
      if (!accordionItem.classList.contains('expanded')) {
        // First expand Level 1
        accordionItem.classList.add('expanded');
        accordionBody.classList.add('show');
        accordionArrow.classList.add('rotated');
        
        // Fetch implants data if not available
        const currentSummary = this.uploadedSummary.find((el) => el.id == itemId);
        if (currentSummary && !currentSummary.implants) {
          this.getBulkUploadSummaryDetails(event, itemId);
        }
      }
    } else if (level === 'level2') {
      // Open Level 3 (Stocks) - first ensure Level 2 is expanded
      const implantItem = event.target.closest('.implant-item');
      const stocksContainer = implantItem.querySelector('.stocks-container');
      const implantArrow = implantItem.querySelector('.implant-arrow');
      
      if (!implantItem.classList.contains('expanded')) {
        // First expand Level 2
        implantItem.classList.add('expanded');
        stocksContainer.classList.add('show');
        implantArrow.classList.add('rotated');
      }
    }
  }
  
  private getAccordionItemId(accordionItem: Element): string {
    // Find the item ID from the data or by matching with uploadedSummary array
    const uploadDateElement = accordionItem.querySelector('.upload-date');
    const implantCountElement = accordionItem.querySelector('.implant-count');
    
    if (uploadDateElement && implantCountElement) {
      const uploadDate = uploadDateElement.textContent.trim();
      const implantCount = implantCountElement.textContent.trim().split(' ')[0];
      
      // Find matching item in uploadedSummary
      const matchingItem = this.uploadedSummary.find(item => 
        this.timestampFormat(item.uploaded_at, "DD/MM/YYYY") === uploadDate &&
        item.implant_count.toString() === implantCount
      );
      
      return matchingItem ? matchingItem.id : null;
    }
    
    return null;
  }

  statusColor(status: string){
    if (status === 'pending') {
      return 'text-pending';
    }else if(status === 'in progress'){
      return 'text-in-progress';
    }
    return 'text-completed';
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    console.log('Switching to tab:', tab);
    this.getBulkUploadSummary("", this.activeTab);
  }

  connectToPrinter(): void {
    this.isPrinterLoader = true;
    this.warehouseService.connectToPrinter().subscribe({
      next: (res) => {
        if (res && ((res['ZBI STATUS'] == 'READY') || (res['ZPL MODE'] == 'ZPL II'))) {
          this.isPrinterConnected = true;
        } else {
          this.isPrinterConnected = false;
        }
        this.isPrinterLoader = false;
      },
      error: (err) => {
        this.isPrinterConnected = false;
        this.isPrinterLoader = false;
        console.error(err);
      },
      complete: () => {
        this.isPrinterLoader = false;
      }
    });
  }

  doPrintAll($event: Event, item: any, implant_id: string = null, stock_id: string = null): void {
    if ($event) $event.stopPropagation();
    if (this.isPrinterConnected) {
      let callback_data = {
        event: $event,
        item: item,
        implant_id: implant_id,
        stock_id: stock_id,
      }

      this.getBulkUploadSummaryDetails($event, item?.id, this.doPrintAllCallback.bind(this), callback_data);
    }
  }
  doPrintAllCallback(data: any, callback_data: any): void {
    let print_tags = [];
    if (data && data?.length > 0) {
      data.forEach(product => {
        if (product && product?.product_id && product?.stocks && product?.stocks?.length > 0 && ((!callback_data?.implant_id) || (product?.id == callback_data?.implant_id))) {
          // product?.status != 'printed' && 
          product?.stocks.forEach(stock => {
            if (stock) {
              stock.warehouse_product_id = product?.id;
              stock.product_id = product?.product_id;
              stock.product_name = product?.product_name;
              stock.batch_no = product?.batch_no;
              if (!callback_data?.stock_id) print_tags.push(stock);
              else if (stock.id == callback_data?.stock_id) print_tags.push(stock);
            }
          });
        }
      });
    }
    if (print_tags && print_tags.length > 0) {
      let input = {
        tags: print_tags
      };
      console.log(print_tags, input);
      this.warehouseService.printerTags(input).subscribe({
        next: (res) => {
          if (res && res?.tags) {
            this.warehouseService.updatePrintLabelStatus({warehouse_products: res?.tags}).subscribe({
              next: (res) => {
                if (res && res?.success) {
                  this.getBulkUploadSummaryDetails(callback_data?.event, callback_data?.item?.id);
                }
              },
              error: (err) => {
                console.error(err);
              },
              complete: () => {}
            });
          }
        },
        error: (err) => {
          console.error(err);
        },
        complete: () => {}
      });
    }
  }
}
